import { API_URL } from '../services/constants';

interface ApiRequestOptions extends RequestInit {
  headers?: HeadersInit;
}

export async function makeApiRequest(
  endpoint: string,
  options: ApiRequestOptions = {},
) {
  const baseUrl = API_URL;
  const refreshTokenEndpoint = `${baseUrl}/admin-refresh-token/generate-new-access-token`;
  const refreshAndAccessTokenEndpoint = `${baseUrl}/admin-refresh-token/generate-new-refresh-and-access-token`;

  async function fetchWithRetry(retryCount = 0) {
    const accessToken = localStorage.getItem('accessToken');
    
    const response = await fetch(`${baseUrl}${endpoint}`, {
      ...options,
      headers: {
        ...options.headers,
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`,
      },
    });

    const responseData = await response.json();
    
      
    const statusCode = responseData.status_code;
    if (statusCode === 401 && retryCount === 0) {
    

      var refreshToken = localStorage.getItem('refreshToken');
      

      if (!refreshToken) {
        throw new Error('Oturum Süreniz dolmuştur. Lütfen tekrar giriş yapın.');
      }

      const refreshResponse = await fetch(
        `${refreshTokenEndpoint}?refresh_token=${refreshToken}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
        },
      );

      const refreshData = await refreshResponse.json();
      
      

      if (refreshData.status_code === 401) {
        // Refresh token expired, try to get both new tokens
        const userData = JSON.parse(localStorage.getItem('userData') || '{}');
        const adminId = userData.id;

        const newTokensResponse = await fetch(
          `${refreshAndAccessTokenEndpoint}?admin_id=${adminId}`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
          },
        );

        const newTokensData = await newTokensResponse.json();
        
        //aşağıdaki şartı değiştir
        if (newTokensData.data && !newTokensData.error) {
          const { access_token, refresh_token } = newTokensData.data;
          localStorage.setItem('accessToken', access_token);
          localStorage.setItem('refreshToken', refresh_token);
          return await fetchWithRetry(retryCount + 1);
        } else {
          localStorage.removeItem('accessToken');
          localStorage.removeItem('refreshToken');
          throw new Error(
            'Oturum süreniz dolmuştur. Lütfen tekrar giriş yapın.',
          );
        }
      }

      if (refreshData.data && !refreshData.data.error) {
        
        const { access_token } = refreshData.data;
        console.log('access_token changed', access_token);
        localStorage.setItem('accessToken', access_token);
        return await fetchWithRetry(retryCount + 1);
      }
    }
    if (responseData?.error) {
      return {
        error: responseData?.message || 'Bilinmeyen bir hata oluştu',
        status: responseData.data?.status_code,
      };
    }

    return {
      data: responseData.data,
      status: responseData.status_code,
    };
  }

  try {
    return await fetchWithRetry();
  } catch (error) {
    return {
      error:
        error instanceof Error ? error?.message : 'Bilinmeyen bir hata oluştu',
      status: 500,
    };
  }
}
